import React from 'react';
import { BookOpenIcon, BuildingIcon, BrainIcon, MapIcon, ShieldIcon } from 'lucide-react';
export function WhatYouGet() {
  return <section className="bg-slate-900 text-white py-24 px-4 sm:px-6 lg:px-8" data-id="element-183">
      <div className="max-w-5xl mx-auto" data-id="element-184">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-185">
          Lo que obtienes hoy
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-186">
          {/* Item 1 */}
          <div className="bg-slate-800 rounded-2xl p-8 border border-slate-700 hover:border-amber-500/50 transition-colors" data-id="element-187">
            <div className="w-12 h-12 bg-amber-500/20 rounded-xl flex items-center justify-center mb-6" data-id="element-188">
              <BookOpenIcon className="w-6 h-6 text-amber-500" data-id="element-189" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-190">
              Manual "El Método del Sobre Digital"
            </h3>
            <p className="text-slate-400" data-id="element-191">
              El paso a paso para configurar tu sistema en 30 minutos. Sin
              relleno, directo al grano.
            </p>
          </div>

          {/* Item 2 */}
          <div className="bg-slate-800 rounded-2xl p-8 border border-slate-700 hover:border-amber-500/50 transition-colors" data-id="element-192">
            <div className="w-12 h-12 bg-amber-500/20 rounded-xl flex items-center justify-center mb-6" data-id="element-193">
              <BuildingIcon className="w-6 h-6 text-amber-500" data-id="element-194" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-195">Configuración Bancaria</h3>
            <p className="text-slate-400" data-id="element-196">
              Cómo usar bolsillos, apartados y billeteras virtuales para
              automatizar tus ahorros sin esfuerzo.
            </p>
          </div>

          {/* Item 3 */}
          <div className="bg-slate-800 rounded-2xl p-8 border border-slate-700 hover:border-amber-500/50 transition-colors" data-id="element-197">
            <div className="w-12 h-12 bg-amber-500/20 rounded-xl flex items-center justify-center mb-6" data-id="element-198">
              <BrainIcon className="w-6 h-6 text-amber-500" data-id="element-199" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-200">
              La Regla de los 3 Segundos
            </h3>
            <p className="text-slate-400" data-id="element-201">
              El filtro psicológico definitivo para eliminar compras por impulso
              para siempre.
            </p>
          </div>

          {/* Item 4 */}
          <div className="bg-slate-800 rounded-2xl p-8 border border-slate-700 hover:border-amber-500/50 transition-colors" data-id="element-202">
            <div className="w-12 h-12 bg-amber-500/20 rounded-xl flex items-center justify-center mb-6" data-id="element-203">
              <MapIcon className="w-6 h-6 text-amber-500" data-id="element-204" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-205">Hoja de Ruta del Día 1</h3>
            <p className="text-slate-400" data-id="element-206">
              Una plantilla práctica para distribuir tu próximo sueldo
              perfectamente desde el primer momento.
            </p>
          </div>

          {/* Item 5 */}
          <div className="bg-slate-800 rounded-2xl p-8 border border-slate-700 hover:border-amber-500/50 transition-colors md:col-span-2 lg:col-span-1" data-id="element-207">
            <div className="w-12 h-12 bg-amber-500/20 rounded-xl flex items-center justify-center mb-6" data-id="element-208">
              <ShieldIcon className="w-6 h-6 text-amber-500" data-id="element-209" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-210">Protocolo Anti-Inflación</h3>
            <p className="text-slate-400" data-id="element-211">
              Cómo ajustar tus sobres cuando los precios suben sin que colapse
              tu estilo de vida.
            </p>
          </div>
        </div>
      </div>
    </section>;
}